import {
    Divider,
    Grid,
    IconButton,
    InputBase,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core"
import SearchIcon from "@material-ui/icons/Search"
import { useContext, useState } from "react"
import SiteContext from "../../../contexts/SiteContext"
import { TextosContext } from "../../../contexts/TextosContext"
import { removeAcento } from "../../../services/functions"

const useStyles = makeStyles(theme => ({
    container: {
        height: "3em",
        position: "relative",
        justifyContent: "end",
        alignItems: "center",
        marginBottom: props => (props.temProdutoNaPesquisa ? "2rem" : "10rem"),
    },
    searchContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
    },
    searchIcon: {
        padding: "8px 8px 8px 8px",
    },
    inputPesquisaProduto: {
        padding: 0,
        width: "80%",
    },
    divider: {
        margin: "8px",
    },
    naoEncontrado: {
        display: "flex",
        minHeight: "100px",
        alignItems: "center",
        justifyContent: "center",
        margin: "12px 0",
        "& > span": {
            fontWeight: 500,
            fontSize: "24px",
            [theme.breakpoints.down("sm")]: {
                fontSize: "16px",
            },
            [theme.breakpoints.down("xs")]: {
                fontSize: "12px",
            },
        },
    },
}))

export default function BuscaProdutos(props) {
    const { cardapio } = useContext(SiteContext)
    const { textos } = useContext(TextosContext)

    const [temProdutoNaPesquisa, setTemProdutoNaPesquisa] = useState(true)

    const classes = useStyles({ temProdutoNaPesquisa })

    const procurarProduto = e => {
        const valorPesquisa = removeAcento(e.target.value.toLocaleLowerCase())
        let temResultado = false
        cardapio.categorias.forEach(categoria => {
            const categoriaSelecionada = document.getElementById(`categoria-${categoria.id}`)

            if (!categoriaSelecionada) return

            let qtd = 0
            const nomeCategoria = removeAcento(categoria.nome)
            categoria.produtos.forEach(produto => {
                const nomeProduto = removeAcento(produto.nome.toLocaleLowerCase())
                const descricaoProduto = removeAcento(produto.descricao?.toLocaleLowerCase())
                const cardProduto = document.getElementById(`produto-${produto.id}`)

                if (!cardProduto) return

                if (
                    nomeCategoria.includes(valorPesquisa) ||
                    nomeProduto.includes(valorPesquisa) ||
                    descricaoProduto.includes(valorPesquisa)
                ) {
                    qtd++
                    temResultado = true
                    cardProduto.style.display = ""
                } else {
                    cardProduto.style.display = "none"
                }
            })

            if (qtd === 0) categoriaSelecionada.style.display = "none"
            else categoriaSelecionada.style.display = ""
        })
        setTemProdutoNaPesquisa(temResultado)
    }

    return (
        <Grid container fullwidth className={classes.container}>
            <Grid item xs={12} className={classes.divider}>
                <Divider />
            </Grid>
            <Grid item xs={12}>
                <Paper square className={classes.searchContainer}>
                    <IconButton
                        onClick={() => document.getElementById("inputPesquisaProduto").focus()}
                        className={classes.searchIcon}
                    >
                        <SearchIcon className="SearchIconPesquisar" />
                    </IconButton>
                    <InputBase
                        placeholder={`${textos.procurar}...`}
                        onChange={procurarProduto}
                        id="inputPesquisaProduto"
                        className={classes.inputPesquisaProduto}
                        inputProps={{ "aria-label": "search" }}
                        elevation={2}
                    />
                    <input id="InputInvisible"></input>
                </Paper>
            </Grid>
            <Grid item xs={12} className={classes.divider}>
                <Divider />
            </Grid>
            {!temProdutoNaPesquisa && (
                <Grid item xs={12} className={classes.naoEncontrado}>
                    <Typography component="span">
                        Não encontramos nenhum produto com base em sua pesquisa
                    </Typography>
                </Grid>
            )}
        </Grid>
    )
}
